export const NONE = 'none'
export const CREATED = 'created'
export const DATA_PROCESSING = 'data_processing'
export const INDEX_PROCESSING = 'index_processing'
export const INDEX_HALTED = 'index_halted'
export const PARTIALLY_FINISHED = 'partially_finished'
export const FINISHED = 'finished'
export const RESTARTED = 'restarted'
export const ERROR = 'error'
export const INDEX_UNKNOWN = 'index_unknown'

// Unified provider/indexer status reported by the engine (mirrors the indexer's
// provider-execution-status enum). Providers map their native statuses onto these three values.
export const PROVIDER_STATUS = Object.freeze({
  IN_PROGRESS: 'inProgress',
  SUCCESS: 'success',
  ERROR: 'error'
})

export function getIndexExecutionStatus(index) {
  const lastIndexExecution = index?.last_index_execution
  const azureStatus = index?.provider_status || index?.azure_status
  const amioIndexerStatus = lastIndexExecution?.status

  if (amioIndexerStatus && amioIndexerStatus !== 'finished') {
    switch (amioIndexerStatus) {
      case 'created':
      case 'queued':
        return CREATED
      case 'running':
        return DATA_PROCESSING
      case 'aborted':
        return PARTIALLY_FINISHED
      case 'restarted':
        return RESTARTED
      case 'error':
        return ERROR
      default:
        break
    }
  }

  const azureIndexerStatus = azureStatus?.status
  if (!amioIndexerStatus && !azureIndexerStatus) {
    return NONE
  }

  switch (azureIndexerStatus) {
    case PROVIDER_STATUS.SUCCESS: // 'success'
    case 'reset': // legacy Azure value
      return FINISHED
    case PROVIDER_STATUS.IN_PROGRESS: // 'inProgress'
      return INDEX_PROCESSING
    case 'transientFailure': // legacy Azure value (still retrying)
      return INDEX_HALTED
    case PROVIDER_STATUS.ERROR: // 'error' (unified)
    case 'persistentFailure': // legacy Azure value
      return ERROR
    default:
      return INDEX_UNKNOWN
  }
}

export function isIndexExecutionSuccess(index) {
  return getIndexExecutionStatus(index) === FINISHED
}

export function getIndexGroupExecutionStatus(indexes = []) {
  if (!indexes.length) return NONE

  if (indexes.every(isIndexExecutionSuccess)) return FINISHED

  const statuses = indexes.map(getIndexExecutionStatus)
  if (statuses.some(status => status === ERROR)) return ERROR
  if (statuses.some(status => [DATA_PROCESSING, INDEX_PROCESSING, CREATED, RESTARTED, INDEX_HALTED, INDEX_UNKNOWN].includes(status))) {
    return DATA_PROCESSING
  }
  if (statuses.some(status => status === PARTIALLY_FINISHED)) return PARTIALLY_FINISHED

  return NONE
}
